{
    "component-card-search-list.empty-state.title.non-final": "<strong>Koble dette repositoriet til en programvarekomponent</strong>",
    "component-card.add-chat-channel": "Legg til chat-kanal",
    "component-card.chat-channels": "Chat-kanaler",
    "component-card.expander.show-more-link": "Vis {formattedCount} til"
}
